export default __webpack_public_path__ + "static/media/tokenDemandMb2.39d64500.png";